module.exports = __webpack_public_path__ + "static/media/PORKYS_-01.c6b5de80.svg";